import {
    OrderLeftColorCode,
    OrderTypeIcon,
    DetailsContianer,
    IconDetailsContainer,
    AccountDiv,
    AccountNumber,
    AccountNameTrunc,
    MyCaseRefNumber,
    RegularText,
    NormalDiv,
} from './Order.styled';
import React from 'react';
import { convertTime24To12, fromOrderTypeToModuleName } from 'src/utils/util';
import Card from 'src/common/refactoredComponents/card/Card';
import DraftNotSubmitted from 'src/assets/images/DraftNotSubmitted.svg';
import PartiallyShipped from 'src/assets/images/PartiallyShipped.svg';
import UsagePending from 'src/assets/images/UsagePending.svg';
import ShippedComplete from 'src/assets/images/ShippedComplete.svg';
import BillingIssues from 'src/assets/images/BillingIssues.svg';
import FullyInvoiced from 'src/assets/images/FullyInvoiced.svg';
import InProcess from 'src/assets/images/InProcess.svg';
import PaymentInformationNeeded from 'src/assets/images/PaymentInformationNeeded.svg';
import SubmittedPendingPriceOverride from 'src/assets/images/SubmittedPendingPriceOverride.svg';
import UsageCompleted from 'src/assets/images/UsageCompleted.svg';
import UsageSubmittedPendingInvoice from 'src/assets/images/UsageSubmittedPendingInvoice.svg';
import moment from 'moment';
import UnidItem from 'src/common/components/unidItem/UnidItem';
import { sizes } from 'src/styles/Media.styled';
import { useDispatch, useSelector } from 'react-redux';
import {
    getOrderSummaryData,
    setOrderStatus,
    setOrderSummaryModalState,
} from 'src/pages/orders/redux/actions';
import { useTranslation } from 'react-i18next';
import { ENABLED, ORDERS, VISIBLE } from 'src/constants/appConstants';
import { getConfigurations } from 'src/common/redux/actions';

const Order = (props) => {
    const {
        accountName,
        physicianDisplaylName,
        accountNumber,
        HRefId,
        primaryProcedureName,
        orderStatusDescription,
        surgeryStartDate,
        myCaseRef,
        noOfSets,
        className,
        isMastOrder,
        orderType,
        isUsageMastOrder,
        openDetailsModal = () => {},
    } = props;
    const { t } = useTranslation();
    const { patientIdVisibility } = useSelector((state) => state.loginReducer);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const vendorId = t('common.vendorLabel');

    const imageWidth = '40px';

    let statusColorCode = {
            backgroundColor: '',
            borderColor: '',
        },
        imgSrc,
        isDraft = { border: 'none' };

    let surgeryStartDateDateObject = new Date(surgeryStartDate);

    const time = convertTime24To12(surgeryStartDateDateObject);

    if (
        orderStatusDescription === t('orders.orderStatuses.draftNotSubmitted')
    ) {
        statusColorCode = {
            backgroundColor: '#A8A8A8',
            borderColor: '#A8A8A8',
        };
        imgSrc = DraftNotSubmitted;
        isDraft = { border: '2px dashed #A8A8A8' };
    } else if (
        orderStatusDescription === t('orders.orderStatuses.shippedComplete') ||
        orderStatusDescription === t('orders.orderStatuses.fullyInvoiced')
    ) {
        statusColorCode = {
            backgroundColor: '#14853D 0% 0% no-repeat padding-box',
            borderColor: '#14853D',
        };
        imgSrc =
            orderStatusDescription === t('orders.orderStatuses.shippedComplete')
                ? ShippedComplete
                : FullyInvoiced;
    } else if (
        orderStatusDescription === t('orders.orderStatuses.billingIssues') ||
        orderStatusDescription === t('orders.index.awaitingPO')
    ) {
        statusColorCode = {
            backgroundColor: '#EB475B 0% 0% no-repeat padding-box',
            borderColor: '#EB475B',
        };
        imgSrc =
            orderStatusDescription === t('orders.orderStatuses.billingIssues')
                ? BillingIssues
                : PaymentInformationNeeded;
    } else if (
        orderStatusDescription === t('orders.orderStatuses.inProcess') ||
        orderStatusDescription ===
            t('orders.orderStatuses.usageSubmittedPendingInvoice')
    ) {
        statusColorCode = {
            backgroundColor: '#0DDCB9 0% 0% no-repeat padding-box',
            borderColor: '#0DDCB9',
        };
        imgSrc =
            orderStatusDescription === t('orders.orderStatuses.inProcess')
                ? InProcess
                : UsageSubmittedPendingInvoice;
    } else if (
        orderStatusDescription === t('orders.orderStatuses.usageCompleted') ||
        orderStatusDescription === t('orders.orderStatuses.usagePending')
    ) {
        statusColorCode = {
            backgroundColor: '#F9D78C 0% 0% no-repeat padding-box',
            borderColor: '#F9D78C',
        };
        imgSrc =
            orderStatusDescription === t('orders.orderStatuses.usageCompleted')
                ? UsageCompleted
                : UsagePending;
    } else if (
        orderStatusDescription ===
        t('orders.orderStatuses.submittedPendingPriceOverride')
    ) {
        statusColorCode = {
            backgroundColor: '#E26D38 0% 0% no-repeat padding-box',
            borderColor: '#E26D38',
        };
        imgSrc = SubmittedPendingPriceOverride;
    } else if (
        orderStatusDescription === t('orders.orderStatuses.partialShipped')
    ) {
        statusColorCode = {
            backgroundColor: '#7ECA2A 0% 0% no-repeat padding-box',
            borderColor: '#7ECA2A',
        };
        imgSrc = PartiallyShipped;
    } else {
        imgSrc = '';
    }

    const getTimeZoneName = () => {
        return moment.tz
            .zone(moment.tz.guess())
            .abbr(new Date().getTimezoneOffset());
    };
    const dispatch = useDispatch();

    const viewSurgeryDetailsClick = () => {
        dispatch(getConfigurations({resourceType: 'visibility', module: fromOrderTypeToModuleName(orderType, isMastOrder, isUsageMastOrder)}, ORDERS));
        dispatch(getOrderSummaryData());
        dispatch(
            setOrderSummaryModalState({
                myCaseRef: myCaseRef,
                orderSummaryModal: true,
            })
        );
        dispatch(
            setOrderStatus({
                orderStatus: orderStatusDescription,
            })
        );
        openDetailsModal();
    };

    return (
        <Card
         id="home-orders-order-card"
        mobileMaxWidth = {'92%'}
      borderLeft ={'none'}
            border={isDraft}
            week={className}
            justifyContent={'space-evenly'}
            onClick={() => viewSurgeryDetailsClick()}
            maxWidth = {'320px'} minWidth = {'320px'}
>
            <OrderLeftColorCode
                orderStatusColor={statusColorCode}
                week={className}
            />

            <IconDetailsContainer week={className}>
                <OrderTypeIcon week={className} width={imageWidth}>
                    {imgSrc ? (
                        <img
                            src={imgSrc}
                            alt="icon"
                            width="auto"
                            height="auto"
                        />
                    ) : (
                        <div style={{ width: `${imageWidth}` }}></div>
                    )}
                </OrderTypeIcon>

                <DetailsContianer week={className} isSetsVisible={noOfSets > 0}>
                    <div className="title">
                        <AccountNameTrunc
                            className="home-order-physician-dt-mask"
                            fontFamily={'AvenirNextWorld Demi'}
                            fontSize="16px"
                        >
                            {physicianDisplaylName ? (
                                t('common.drLabel') +
                                ' ' +
                                `${physicianDisplaylName}`
                            ) : (
                                <div style={{ height: '21px' }}></div>
                            )}
                        </AccountNameTrunc>

                        <div className="time">
                            {time}
                            <span
                                style={{
                                    opacity: '0.5',
                                    marginLeft: '4px',
                                }}
                            >
                                {' '}
                                {getTimeZoneName()}
                            </span>
                        </div>
                    </div>

                    <AccountDiv className="home-order-account-dt-mask" week={className}>
                        <AccountNameTrunc week={className}>
                            {accountName}
                        </AccountNameTrunc>
                        <AccountNumber week={className}>
                            {accountNumber && parseInt(accountNumber, 10)}
                        </AccountNumber>
                    </AccountDiv>

                    {primaryProcedureName ? (
                        <div
                            className="details"
                            style={{
                                // minHeight: '38px'
                                height: 'max-content',
                            }}
                        >
                            {primaryProcedureName}
                        </div>
                    ) : (
                        <div
                            className="details"
                            style={{
                                // minHeight: '38px'
                                height: 'max-content',
                            }}
                        >
                            {''}
                        </div>
                    )}
                    <div className="refernce-number">
                        {countryISOCode === 'JP' && (
                            <div>
                                <span>
                                    <span
                                        style={{
                                            color: '#585858',
                                            fontFamily: 'AvenirNextWorld Demi',
                                        }}
                                    >
                                        {t(
                                            'orders.priceOverrideHistoryStatus.Ordertype'
                                        )}
                                    </span>
                                    &nbsp;
                                    <span
                                        style={{
                                            color: '#140f4b',
                                            fontFamily:
                                                'AvenirNextWorld Regular',
                                        }}
                                    >
                                        {isMastOrder
                                            ? t('orders.orderTypes.MAST')
                                            : orderType === 'ZLC'
                                            ? t(
                                                  'templates.surgeryTemplate.surgery'
                                              )
                                            : t(
                                                  'reportUsage.review.discrepancy.RowHeaderDesktop.usage'
                                              )}
                                    </span>
                                </span>
                            </div>
                        )}
                        {HRefId ? (
                            <>
                                <span className="home-order-href-id-dt-mask">
                                    <span
                                        style={{
                                            color: '#585858',
                                            fontFamily: 'AvenirNextWorld Demi',
                                        }}
                                    >
                                        {HRefId.length > 0 &&
                                            t('common.hrefLabel') + ' '}
                                    </span>
                                    {HRefId}
                                </span>
                                <br />
                            </>
                        ) : (
                            <div style={{ minHeight: '20px' }}></div>
                        )}
                        <MyCaseRefNumber week={className}>
                            <div>{myCaseRef}</div>
                            {noOfSets ? (
                                <div className="setCount" week={className}>
                                    {noOfSets > 1
                                        ? `${noOfSets} ${t('common.setsLabel')}`
                                        : `${noOfSets} ${t(
                                              'common.setsLabel'
                                          )}`}
                                </div>
                            ) : (
                                <div
                                    style={{
                                        height: className ? '20px' : '0px',
                                        marginBottom: className
                                            ? '10px'
                                            : '0px',
                                    }}
                                ></div>
                            )}
                        </MyCaseRefNumber>
                    </div>
                    <div>
                        {props.unidCaseNo ? (
                            <div id="home-orders-order-unid-item-container" onClick={(e) => e.stopPropagation()}>
                                <UnidItem
                                    uniDIdUrl={props.unidIdURL}
                                    uniDId={props.unidCaseNo}
                                    planStatus={props.unidPlanStatus}
                                    isMobileView={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? true
                                            : false
                                    }
                                    fromCalendarPage={true}
                                    week={className}
                                    isShowStatus={true}
                                    showPlan={props.isMtoStatus}
                                />
                            </div>
                        ) : (
                            <div
                                style={{ height: className ? '42px' : '21px' }}
                            ></div>
                        )}
                        {props.secondaryVendorCaseNo ? (
                            <NormalDiv
                                margin={
                                    props.unidCaseNo ? '22px 0px 0px 0px' : null
                                }
                            >
                                <RegularText
                                    color="#4F4F4F"
                                    fontSize="12px"
                                    margin="0 2px 0 0"
                                >
                                    {vendorId}
                                </RegularText>

                                <RegularText color="unset" fontSize="12px">
                                    {props.secondaryVendorCaseNo}
                                </RegularText>
                            </NormalDiv>
                        ) : null}
                    </div>
                    <footer className="footer" week={className}>
                        {orderStatusDescription ? (
                            <div style={{ minHeight: className ? '42px' : '' }}>
                                {orderStatusDescription}
                            </div>
                        ) : (
                            <div style={{ minHeight: className ? '42px' : '' }}>
                                {''}
                            </div>
                        )}
                    </footer>
                </DetailsContianer>
            </IconDetailsContainer>
        </Card>
    );
};

export default Order;
